import React from "react";
// import HttpService from '../utils/Http.services';
import { siteConfig, siteTheme } from "../../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../Configurer";
// import ProfileImage from "../components/partials/ProfileImage";
// import TableViewer from "../components/TableViewer";
import { v4 as uuidv4 } from 'uuid';
import Collapsible from "react-collapsible";
import DiagramComponent from "./diagram/DiagramComponent";
import { diagramComponents, diagramGroups } from "../../variables/diagramFunctions";
import DiagramPath from "./diagram/DiagramPath";
import DiagramSidebar from "./diagram/DiagramSidebar";
import { debounce, throttle } from 'throttle-debounce';
import Modal from '../Modal'
import FormViewer from '../FormViewer'
import LoaderButton from "../LoaderButton";
import { checkTranslation, translate } from "../../utils/useful";
import HttpServices from '../../utils/Http.services';
import { getBoundingClientRect } from '../../utils/functions';
import DiagramComponentConfig from "./diagram/DiagramComponentConfig";
import DiagramVariablesSidebar from "./diagram/DiagramVariablesSidebar";

// const 

class DiagramEditor extends React.Component {

    miniWidth = 120

    state = {
        data: {},
        components: {},
        paths: {},
        nodes: {},
        zoom: 1,

        optionsList: [
            // { key: 'variables', label: 'variables' },
            // { key: 'calculator', label: 'calculatorTET' },
            // { key: 'function-name', label: 'Function Name' },
            // { key: 'function-test', label: 'Function test' },
        ]

    }

    // debounceFunc = throttle(1, false, (pathKey, as, points) => {
    debounceFunc = debounce(1, false, (paths) => {

        this.setState({ paths })

    });


    componentDidMount() {
        this.resizeListener = window.addEventListener('resize', this.updateMiniViewSize)
        setTimeout(() => {
            this.updateMiniViewSize()
        }, 10);
        this.fetchData()
        // this.fetchVariables()

    }



    componentWillUnmount() {
        window.removeEventListener('resize', this.updateMiniViewSize)
        this.removeDoneEventListener()
    }


    fetchData = () => {

        let id = this.props?.data?.params?.id

        if (id) {
            this.setState({ isLoadingData: true })

            HttpServices.request('getOneApplet', { id }, (fetchResult, fetchError, fetchStatus) => {
                this.setState({ isLoadingData: false })
                // console.log(fetchError)
                if (fetchError) {
                    this.setState({ pageStatus: fetchStatus })
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }
                if (!fetchResult.info?.workflow) {
                    fetchResult.info.workflow = {}
                }
                // console.log(fetchResult)
                this.setState({
                    data: fetchResult.info,
                    components: fetchResult.info?.workflow.components ?? {},
                    paths: fetchResult.info?.workflow.paths ?? {},
                    nodes: fetchResult.info?.workflow.nodes ?? {},
                }, () => {
                    this.updateMiniViewSize()
                    // this.fetchVariables()
                })
            })
        }
    }



    fetchVariables = () => {
        // this.fetchTings()
        let data = {}
        data.applet = this.props.variables.appletId
        console.log('fetchvar', data)
        return
        HttpServices.request('getVariables', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            console.log('fetchReusult', fetchResult.info)
            console.log('fetchReusult', fetchResult.info)
            this.setState({ variables: fetchResult.info }, () => {
                this.varSidebarView.open()
            })
        })
    }


    fetchTings = () => {
        HttpServices.request('getAppletThings', { applet: this.state.data?._id }, (fetchResult, fetchError, fetchStatus) => {
            this.setState({ isLoadingData: false })
            // console.log(fetchError)
            if (fetchError) {
                // this.setState({ pageStatus: fetchStatus })
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            console.log(fetchResult)
            this.setState({ things: fetchResult.info }, () => {
                this.createOptionsList()
            })
        })
    }



    createOptionsList() {
        let list = []
        // list.push({ key: 'things', label: 'Things', parent: null, hasChildren: true })

        // this.state.things.forEach(connection => {
        //     // console.log(connection.thing)
        //     list.push({ key: "things." + connection.thing._id, label: connection.thing.name.replaceAll(' ', '-'), parent: "things", image: connection.thing.images, hasChildren: true })

        //     if (connection.thing.structure) {
        //         connection.thing.structure.forEach(structure => {
        //             list.push({ key: 'things.' + connection.thing.name.replaceAll(' ', '-') + '.' + structure.dataObject + '(' + connection.thing._id + ")", label: structure.label, parent: "things." + connection.thing._id })
        //         });
        //     }
        // });

        // // console.log(this.state.tempInputs)

        // if (Array.isArray(this.state.tempInputs)) {

        //     list.push({ key: 'inputs', label: 'Inputs', parent: null, hasChildren: true })

        //     this.state.tempInputs.forEach(input => {
        //         list.push({ key: "inputs." + input.label, label: input.label, parent: "inputs", hasChildren: false })
        //     })
        // }
        // console.log("createOptionsList")
        // console.log(list)
        this.setState({ optionsList: list })
    }


    formLiveChange = (data, init) => {
        // console.log(init)
        // console.log("formLiveChange")
        if (this.state.currentComponent?.type == 'condition') {
            this.setState({ tempInputs: data.inputs }, () => {
                this.createOptionsList()
            })
            // console.log(data)

        } else {
            if (init) {
                this.setState({ tempInputs: [{ label: 'input' }] }, () => {
                    this.createOptionsList()
                })
            }
        }
    }



    postRigram = () => {


        let data = {
            _id: this.state.data._id,
            workflow: {
                components: this.state.components,
                paths: this.state.paths,
                nodes: this.state.nodes
            }
        }

        // console.log(data)

        this.setState({ isLoadingPost: true })
        // console.log('datais10000', data)
        HttpServices.request("postRigram", data, (fetchResult, fetchError) => {
            this.setState({ isLoadingPost: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                return
            }

            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postSuccesfully', description: '{{lang}}info.postSuccesfullyDesc' })

        })

    }



    onDragStart = (e, prop, type) => {

        // console.log("onDragStart")
        if (!e.dataTransfer) {
            e.dataTransfer = {}
        }
        // console.log(prop)
        // console.log(type)
        // console.log(this[prop.key])


        if (type == 'component') {
            this.draggingId = prop.key
            if (e.dataTransfer.setDragImage) {
                e.dataTransfer.setDragImage(this.ghost, 0, 0);
            }
            if (this[prop.key]) {
                let bound = getBoundingClientRect(this[prop.key].container)

                let clientX = e.clientX
                let clientY = e.clientY

                if (e.touches) {
                    clientX = e.touches[0].clientX
                    clientY = e.touches[0].clientY

                    // document.getElementById('rigramDroppableView').style.overflow = 'hidden'
                    document.getElementById('rigramDroppable').style.overflow = 'hidden'

                }

                this.offsetX = clientX - ((bound.left * 1) + (bound.width * 1 / 2))
                this.offsetY = clientY - ((bound.top * 1) + (bound.height * 1 / 2))

            }
        } else {
            this.offsetX = 0
            this.offsetY = 0
        }

        // console.log(e)

        if (e.dataTransfer.setData) {
            e.dataTransfer.setData('id', prop.key)
            e.dataTransfer.setData('type', prop.key)
        } else {
            e.dataTransfer.id = prop.key
            e.dataTransfer.type = prop.key
        }




    }


    onDrag = (e) => {

        // console.log("onDrag")
        let x = e.clientX /// this.state.zoom
        let y = e.clientY /// this.state.zoom



        let bound = getBoundingClientRect(this.rigramDroppable)
        // console.log(bound)

        if (e.touches) {
            x = e.touches[0].clientX
            y = e.touches[0].clientY
        }

        x = x - bound.left
        y = y - bound.top

        if (x < 0) {
            x = 0
        }

        if (y < 0) {
            y = 0
        }

        let components = this.state.components

        if (this.draggingId && x && y) {

            // console.log(x)
            // console.log(y)

            // console.log(this.rigramDroppable.scrollLeft)
            // console.log(this.rigramDroppable.scrollTop)

            let componentX = (((x - this.offsetX)) + (this.rigramDroppable.scrollLeft)) / this.state.zoom
            let componentY = (((y - this.offsetY)) + (this.rigramDroppable.scrollTop)) / this.state.zoom


            if (componentX < 70) {
                componentX = 70
            }
            if (componentY < 70) {
                componentY = 70
            }

            // console.log(this.draggingId)
            // console.log(componentX)
            // console.log(componentY)


            this[this.draggingId].container.style.left = componentX + 'px'
            this[this.draggingId].container.style.top = componentY + 'px'


            let ratio = (this.miniWidth / this.rigramDroppable.scrollWidth)///this.state.zoom

            this['mini-' + this.draggingId].style.left = (componentX) * ratio * this.state.zoom + 'px'
            this['mini-' + this.draggingId].style.top = (componentY) * ratio * this.state.zoom + 'px'

            components[this.draggingId].positionX = componentX
            components[this.draggingId].positionY = componentY
            // console.log("HEREEE")
            if (components[this.draggingId].paths) {
                let paths = this.state.paths
                Object.values(components[this.draggingId].paths).forEach(path => {
                    // this.debounceFunc(path.key, path.as, [componentX, componentY]);
                    paths[path.key][path.as] = [componentX, componentY]

                });

                this.debounceFunc(paths);

            }
        }

        if (x >= this.props.width - 100) {

            this.rigramDroppable.scrollLeft = this.rigramDroppable.scrollLeft + 1
            // this.rigramDroppable.scrollWidth = this.rigramDroppable.scrollWidth + 100


        }

        if (y >= this.props.height - 100) {
            this.rigramDroppable.scrollTop = this.rigramDroppable.scrollTop + 1


        }



    }

    onDragOver = (e) => {
        e.stopPropagation();
        e.preventDefault();
    }





    onDrop = (e) => {
        // console.log("onDrop")
        // console.log(e.touches)
        // console.log(e.changedTouches)

        e.preventDefault()


        let components = this.state.components
        let x = e.clientX
        let y = e.clientY


        if (e.changedTouches) {
            x = e.changedTouches[0].clientX
            y = e.changedTouches[0].clientY
        }

        let bound = getBoundingClientRect(this.rigramDroppable)

        x = x - bound.left
        y = y - bound.top



        let componentX = (((x - this.offsetX)) + (this.rigramDroppable.scrollLeft)) / this.state.zoom
        let componentY = (((y - this.offsetY)) + (this.rigramDroppable.scrollTop)) / this.state.zoom

        let ratio = this.miniWidth / this.rigramDroppable.scrollWidth

        // console.log(e.dataTransfer)
        let id
        let type
        if (e.dataTransfer.getData) {
            id = e.dataTransfer.getData('id')
            type = e.dataTransfer.getData('id')
        } else {
            id = e.dataTransfer.id
            type = e.dataTransfer.id

        }



        if (id && components[id]) {

            components[id].positionX = componentX //e.clientX + this.rigramDroppable.scrollLeft
            components[id].positionY = componentY //e.clientY + this.rigramDroppable.scrollTop
            this.setState({ components }, () => {
                // console.log("components", components)
                // console.log("components", this.state.paths)
                if (components[id].paths) {
                    let paths = this.state.paths
                    // console.log(paths)
                    Object.values(components[id].paths).forEach(path => {
                        paths[path.key][path.as] = [componentX, componentY]

                    });

                    this.setState({ paths })
                }
            })

        } else {
            id = uuidv4()
            if (diagramComponents[type]) {
                let nodes = diagramComponents[type].defaultNodes ?? {}
                let title = diagramComponents[type].title
                let UI = diagramComponents[type].UI
                let group = diagramComponents[type].group

                // let settings = diagramComponents[type].settings

                // let title = diagramComponents[type].title

                // console.log(id)
                components[id] = { key: id, type, group, positionX: componentX, positionY: componentY, nodes, title, UI } // TODO DEFAULT NODES - Title
                this.setState({ components }, () => {
                    console.log('nodes is', this.state.nodes)

                    this[id].container.style.left = components[id].positionX + 'px'
                    this[id].container.style.top = components[id].positionY + 'px'

                    this['mini-' + id].style.left = (components[id].positionX) * ratio * this.state.zoom + 'px'
                    this['mini-' + id].style.top = (components[id].positionY) * ratio * this.state.zoom + 'px'

                })
            }
        }

    }

    dragEnd = (e) => {
        // console.log("dragEnd")
        // let rigramDroppable = document.getElementById('rigramDroppableView')
        // // console.log(rigramDroppable)
        // rigramDroppable.style.overflow = 'auto'

        document.getElementById('rigramDroppableView').style.overflow = 'visible'
        document.getElementById('rigramDroppable').style.overflow = 'auto'



        this.updateMiniViewSize()
    }




    updateMiniViewSize = (e) => {

        if (this.rigramDroppable) {

            let ratio = (this.miniWidth / this.rigramDroppable.scrollWidth)

            let newHeight = this.rigramDroppable.scrollHeight * ratio ///this.rigramDroppable.scrollWidth

            let trackerNewWidth = (this.props.width - 50) * ratio///this.rigramDroppable.scrollWidth)*200
            let trackerNewHeight = (this.props.height / this.rigramDroppable.scrollHeight) * newHeight

            this.miniView.style.height = newHeight + 'px'
            // this.miniView.style.width = newHeight + 'px'

            // console.log(ratio)
            // console.log(trackerNewHeight)
            // console.log(trackerNewWidth)
            // console.log(this.props.height)


            this.miniViewTracker.style.height = trackerNewHeight + 'px'
            this.miniViewTracker.style.width = trackerNewWidth + 'px'


            this.miniViewTracker.style.top = (this.rigramDroppable.scrollTop * ratio) + 'px'
            this.miniViewTracker.style.left = (this.rigramDroppable.scrollLeft * ratio) + 'px'

            Object.values(this.state.components).forEach(component => {
                this.updateMiniViewComponent(component, ratio)
            });
        }

    }


    updateMiniViewComponent(component, sRatio) {
        let ratio = sRatio
        if (!ratio) {
            ratio = (this.miniWidth / this.rigramDroppable.scrollWidth)
        }
        ratio = ratio * this.state.zoom
        this['mini-' + component.key].style.left = (component.positionX) * ratio + 'px'
        this['mini-' + component.key].style.top = (component.positionY) * ratio + 'px'
    }


    handleZoom(type) {

        let zoom = this.state.zoom

        if (type == 'in') {
            if (zoom <= 2) {
                zoom = zoom + 0.2
            }
        }

        if (type == 'out') {
            if (zoom >= 0.5) {
                zoom = zoom - 0.2
            }

        }

        if (type == 'fit') {
            zoom = 1
        }

        this.setState({ zoom }, () => {
            this.updateMiniViewSize()
        })

    }



    toggleMiniView = () => {
        let miniClose = this.state.miniClose == null ? true : !this.state.miniClose
        this.setState({ miniClose })
    }



    setNodesPosition = (componentKey, nodes, componentWH) => {
        // console.log(nodes)
        let components = this.state.components
        // Object.values(nodes).forEach(node => {
        //     node.relativePosition.x = this.rigramDroppable.scrollLeft + node.relativePosition.x
        //     node.relativePosition.y = this.rigramDroppable.scrollTop + node.relativePosition.y
        // });

        components[componentKey].nodes = Object.assign({}, nodes)
        if (componentWH) {
            components[componentKey].width = componentWH.width
            components[componentKey].height = componentWH.height
        }

        // console.log(components)

        this.setState({ components })
        // console.log(components[componentKey])

    }


    nodeMouseDown = (component, node, e) => {
        // console.log("nodeMouseDown")
        let components = this.state.components

        if (this.state.activePath) {
            let activePath = this.state.activePath
            if (node.type === 'input') {
                // console.log("*")
                let paths = this.state.paths
                let id = uuidv4()
                activePath.id = id

                let x = components[component.key].positionX //+ 
                let y = components[component.key].positionY //+ node.relativePosition.y 

                let endOffset = [node.relativePosition.x, node.relativePosition.y]


                activePath.end = [x, y]
                activePath.endOffset = endOffset

                activePath.ECKey = component.key
                activePath.ENKey = node.key

                paths[id] = activePath


                this.setState({ activePath: null, paths })

                if (!components[component.key].paths) {
                    components[component.key].paths = {}
                }
                if (!components[activePath.SCKey].paths) {
                    components[activePath.SCKey].paths = {}
                }

                components[component.key].paths[id] = { as: 'end', key: id, node: node.key }
                components[activePath.SCKey].paths[id] = { as: 'start', key: id, node: activePath.SNKey }

                // console.log(paths)
                // console.log(components)

                // paths.push()

            }
        } else {

            if (node.type === 'output') {


                // let x = components[component.key].positionX + node.relativePosition.x //+ node.relativePosition.width / 2
                // let y = components[component.key].positionY + node.relativePosition.y //+ node.relativePosition.height / 2


                let x = components[component.key].positionX //+ node.relativePosition.x 
                let y = components[component.key].positionY //+ node.relativePosition.y 

                let bound = getBoundingClientRect(this.rigramDroppable)




                let clientX = ((e.clientX - bound.left) + (this.rigramDroppable.scrollLeft)) / this.state.zoom
                let clientY = ((e.clientYy - bound.top) + (this.rigramDroppable.scrollTop)) / this.state.zoom


                let start = [x, y]
                let startOffset = [node.relativePosition.x, node.relativePosition.y]

                let end = [clientX, clientY]
                let endOffset = [0, 0]

                // console.log(start)
                // console.log(end)
                let activePath = {}
                activePath.start = start
                activePath.end = end
                activePath.startOffset = startOffset
                activePath.endOffset = endOffset

                activePath.SCKey = component.key
                activePath.SNKey = node.key

                this.setState({ activePath })
                window.addEventListener('mousemove', this.updateActivePath)
                window.addEventListener('touchmove', this.updateActivePath)
                setTimeout(() => {
                    window.addEventListener('touchstart', this.finishActivePath)
                    window.addEventListener('mousedown', this.finishActivePath)

                }, 2);
            }
        }
    }


    updateActivePath = (e) => {
        let activePath = this.state.activePath//{ points: { start, end } }

        let bound = getBoundingClientRect(this.rigramDroppable)


        let clientX = ((e.clientX - bound.left) + (this.rigramDroppable.scrollLeft)) / this.state.zoom
        let clientY = ((e.clientY - bound.top) + (this.rigramDroppable.scrollTop)) / this.state.zoom

        activePath.end = [clientX, clientY]
        // console.log(activePath)
        this.setState({ activePath })
    }


    finishActivePath = (e) => {
        window.removeEventListener('touchmove', this.updateActivePath)
        window.removeEventListener('touchstart', this.finishActivePath)

        window.removeEventListener('mousemove', this.updateActivePath)
        window.removeEventListener('mousedown', this.finishActivePath)

        setTimeout(() => {
            this.setState({ activePath: null })
        }, 300);
    }

    removePath = (id) => {
        let paths = this.state.paths
        let path = paths[id]

        if (path) {
            let components = this.state.components

            // console.log(components)
            // console.log(paths)

            if (components[path.ECKey]?.paths) {
                delete components[path.ECKey].paths[path.id]
            }

            if (components[path.SCKey]?.paths) {
                delete components[path.SCKey].paths[path.id]
            }

            delete paths[id]

            this.setState({ paths, components })
        }
    }


    removeCurrentComponent = () => {
        let key = this.state.currentComponent.key
        let components = this.state.components
        let paths = this.state.paths
        console.log(paths)
        let pathsToremove = []
        Object.values(paths).forEach((path, index) => {
            if (path.ECKey == key || path.SCKey == key) {
                pathsToremove.push(path)
            }
        });

        this.moreModal.hideModal()
        this.removeConfirmModal.hideModal()

        pathsToremove.forEach(path => {
            this.removePath(path.id)
        });

        delete components[key]
        this.setState({ components, currentComponent: null, paths })

    }



    openMore = (key, isDoubleClick) => {
        // console.log(key)
        let component = this.state.components[key]
        let diagramComponent = diagramComponents[component.type]
        // console.log(component)
        this.setState({ currentComponent: component, currentDiagramComponent: diagramComponent }, () => {

            if (isDoubleClick) {
                this.openConfig()
            } else {
                this.moreModal.showModal()
            }

        })


    }

    openConfig = () => {
        let component = this.state.currentComponent

        // console.log(component)
        let headersData = component.configuration
        // console.log(headersData)

        if (!headersData) {
            headersData = {}
        }

        headersData.label = component.title
        this.setState({ currentHeadersData: headersData }, () => {


            this.diagramComponentConfig.openSidebar()
            // this.configModal.showModal(() => {
            //     // console.log("??INIT")
            //     // setTimeout(() => {
            //     //     if (this.form) {
            //     //         console.log("INIT")
            //     //         this.form.init()
            //     //     } 
            //     // }, 100);

            // })
        })

        window.addEventListener("keypress", this.donePressed)
        // window.addEventListener()
        setTimeout(() => {
            if (this.moreModal) {
                this.moreModal.hideModal()
            }
        }, 100);
    }

    donePressed = (e) => {
        // e.preventDefault()
        if (e?.keyCode == 13) {
            this.ConfigurationDone()
        }
    }

    removeDoneEventListener() {
        window.removeEventListener("keypress", this.donePressed)
    }


    ConfigurationDone = () => {
        let headersData = this.form.getForm()
        if (headersData) {
            let components = this.state.components
            let key = this.state.currentComponent.key
            // let component = components[key]
            components[key].title = headersData.label
            components[key].configuration = headersData

            let nodes = {}
            if (headersData.inputs) {
                console.log(components[key])
                headersData.inputs.forEach(input => {
                    let object = { type: 'input', position: 'left' }
                    object.key = input.label
                    object.label = input.label
                    nodes[input.label] = object
                });
            }

            if (headersData.outputs) {
                headersData.outputs.forEach(output => {
                    let object = { type: 'output', position: 'right' }
                    object.key = output.label
                    object.label = output.label
                    nodes[output.label] = object
                });
            }

            if (Object.keys(nodes).length > 0) {
                components[key].nodes = nodes
            }

            this.setState({ components }, () => {
                this.configModal.hideModal()

                if (Object.keys(nodes).length > 0) {
                    this[key].setNodesPosition()
                    setTimeout(() => {
                        this.repositionPaths(key)
                    }, 40);
                }

                console.log(this.state.components)
                console.log(this.state.paths)

            })
        }

    }


    repositionPaths(key) {
        let paths = this.state.paths
        let components = this.state.components
        let nodes = components[key].nodes
        // console.log(nodes)

        let x = components[key].positionX
        let y = components[key].positionY

        if (paths) {
            Object.values(paths).forEach(path => {
                let inputKey = null
                if (path.SCKey == key) {
                    inputKey = "SNKey"
                }
                if (path.ECKey == key) {
                    inputKey = "ENKey"
                }

                if (inputKey) {

                    let connectedNode

                    Object.values(nodes).forEach(node => {
                        if (node.key == path[inputKey]) {
                            connectedNode = node
                        }
                    })

                    if (connectedNode) {

                        if (inputKey == "SNKey") {
                            path.start = [x, y]
                            path.startOffset = [connectedNode.relativePosition.x, connectedNode.relativePosition.y]
                        }

                        if (inputKey == "ENKey") {
                            path.end = [x, y]
                            path.endOffset = [connectedNode.relativePosition.x, connectedNode.relativePosition.y]
                        }

                    } else {
                        this.removePath(path.id)
                    }

                }

            });
        }

        this.setState({ paths }, () => {
        })

    }


    saveButton(action) {
        return (
            <div className="flexc mx-2">

                <LoaderButton
                    onClick={() => action()}
                    isLoading={this.state.isLoading}
                    text={translate("Save").toUpperCase()}
                    type={"Oval"}
                    className=""
                    buttonStyle={{ outline: 'none', backgroundColor: '#222', cursor: 'pointer', padding: '5px 20px', borderRadius: 30, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                    width={30}
                    height={30}
                    color={'#202020'}
                />
                {/* <button className="" onClick={() => action()} style={{ backgroundColor: '#222530', color: '#fff', borderRadius: 40, padding: '5px 20px', fontWeight: 'bold' }}>SAVE</button> */}
                {/* <button onClick={() => this.props.nextStage()} style={{ backgroundColor: '#202020', color: '#fff', borderRadius: 30, padding: '5px 15px', fontWeight: 'bold' }}>NEXT</button> */}
            </div>
        )
    }


    render() {
        let ratio = 1
        if (this.rigramDroppable) {
            ratio = (this.miniWidth / this.rigramDroppable.scrollWidth) * this.state.zoom
        }

        let variables = { appletId: this.state.data?._id }


        return (

            <div className="w-100 d-flex Test diagram  h-100 window-content-radius " style={{ overflow: 'auto' }} >


                {/* 
                <div className="w-100 blur-back" style={{ position: 'fixed', height: 50, borderBottom: '1px solid #eee', zIndex: 8, padding: '10px 20px', backgroundColor: '#ffffffcc' }}>
                    <p>Rigram</p>
                </div> */}

                <DiagramSidebar width={this.props.width} onDragStart={this.onDragStart} onDrop={this.onDrop} onTouchMove={this.onTouchMove} sideOpen={true} hideOverlay={true} draggable={true} />


                <div onScroll={(e) => this.updateMiniViewSize(e)} id="rigramDroppable" ref={el => this.rigramDroppable = el} className="rigramDroppable window-content-radius " onDrop={(e) => this.onDrop(e, 'complete')} onDragOver={(e) => this.onDragOver(e)} style={{ direction: 'ltr', overflow: 'auto', padding: 100, width: '100%', height: '100%', zIndex: 5, backgroundImage: 'url(/images/dg-bg.jpg)', position: 'absolute', }}>
                    <div id="rigramDroppableView" className="w-100 window-content-radius " style={{ transformOrigin: '0px 0px', transform: 'scale(' + this.state.zoom + ')', position: 'absolute', top: 0, left: 0, height: '100%', overflow: 'visible', }}>
                        {Object.values(this.state.components).map((prop, index) => {
                            let thisFunction = diagramComponents[prop.type]
                            return (
                                <DiagramComponent ref={el => this[prop.key] = el} key={prop.key} data={prop} optionsList={this.state.optionsList} openMore={this.openMore} thisFunction={thisFunction} draggingId={this.draggingId} dragEnd={this.dragEnd} onDrag={this.onDrag} onDragStart={this.onDragStart} nodeMouseDown={this.nodeMouseDown} zoom={this.state.zoom} setNodesPosition={this.setNodesPosition} />
                            )
                        })}

                        {Object.values(this.state.paths).map((prop, index) => {
                            // console.log(prop)
                            return (
                                <DiagramPath zIndex={-1} removePath={this.removePath} ref={el => this[prop.key] = el} key={prop.id} data={prop} draggingId={this.draggingId} dragEnd={this.dragEnd} onDrag={this.onDrag} onDragStart={this.onDragStart} zoom={this.state.zoom} />
                            )
                        })}

                        {this.state.activePath && (
                            <DiagramPath zIndex={-1} isActivePath={true} ref={el => this.activePath = el} data={this.state.activePath} />
                        )}


                    </div>
                    {/* <div className='mt-3 px-2'>
                        <LoaderButton
                            onClick={() => this.postRigram()}
                            // isLoading={this.state.isLoading}
                            text={translate("Continue")}
                            // background='linear-gradient(to right, #0796A9, #3391FF)'
                            // background='linear-gradient(to right, #0094FF, #6100FF)'
                            icon={'/assets/icons/angle-right-white2.svg'}
                            backgroundImage='linear-gradient(45deg, #0094FF 0%, #6100FF 51%, #0094FF  100%)'
                            className={'button-interactive-1'}

                        />
                    </div> */}
                </div>


                {/* MINIVIEWER */}
                <div className={"miniViewContainer " + (this.state.miniClose ? 'miniClose' : '')} >
                    <div className="miniViewContainerContent">
                        <button className=" mx-1 flexcc zoomToggleBut" onClick={() => this.toggleMiniView()} >
                            <img src="/images/nexts.png" width="20px" />
                        </button>

                        <div className="miniView" ref={el => this.miniView = el} >

                            {Object.values(this.state.components).map((prop, index) => {
                                let thisFunction = diagramComponents[prop.type]

                                return (
                                    <div onDragEnd={(e) => this.dragEnd()} key={prop.key} ref={el => this['mini-' + prop.key] = el} style={{ padding: 30 / 200, position: 'absolute', transform: 'translate(-50%,-50%)' }}>
                                        <div style={{ backgroundColor: thisFunction?.UI?.bodyColorS == '#fff' ? '#ccc' : thisFunction?.UI?.bodyColorS, width: (prop.width ?? 1) * ratio, height: (prop.height ?? 1) * ratio, borderRadius: thisFunction?.UI?.type == "circle" ? '50%' : 3 }}>
                                        </div>
                                    </div>
                                )
                            })}

                            <div className="mini-view-tracker" ref={el => this.miniViewTracker = el} ></div>
                        </div>

                        <div className="flexcc flex-column mld-2 ">
                            <button className="p-0 m-1 flexcc zoomBut" onClick={() => this.handleZoom('in')} >
                                <img src="/images/zoom-in.svg" width="25px" />
                            </button>
                            <button className="p-0 m-1 flexcc zoomBut" onClick={() => this.handleZoom('out')}>
                                <img src="/images/zoom-out.svg" width="25px" />
                            </button>
                            <button className="p-0 m-1 flexcc zoomBut" onClick={() => this.handleZoom('fit')}>
                                <img src="/images/zoom-fit.svg" width="25px" />
                            </button>
                        </div>
                    </div>
                </div>


                <div ref={el => this.ghost = el} style={{ width: 1, height: 1, position: 'absolute' }}></div>



                <Modal ref={el => this.moreModal = el} maxWidth={300} hideCloseBut={true}>
                    <div className="w-100  text-center position-relative" style={{ backgroundColor: '#ffffff', borderRadius: 8, boxShadow: "0px 0px 50px #10101030" }}>

                        <div className="position-absolute top-0 left-0 w-100" style={{ borderRadius: '8px 8px 0px 0px', zIndex: 0, height: 80, background: 'linear-gradient(to bottom,#CFD3EF,#fff)', }}>

                        </div>
                        <div className="w-100 position-relative" style={{ zIndex: 1, }}>
                            <div className="w-100 px-3 pt-3 pb-2" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', borderRadius: '8px 8px 0px 0px' }}>

                                <div className="text-start pld-2">
                                    {/* <p className="text-smallest mt-2 opacity-5" style={{ lineHeight: 0.5 }}>WHAT TO DO?</p> */}
                                    <p className="text-semibold text-normal">{checkTranslation(this.state.currentComponent?.title)}</p>
                                </div>

                                <div className="cursor-pointer" onClick={() => this.moreModal.hideModal()} style={{ width: 28, height: 28, backgroundColor: '#ffffff90', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img style={{ width: 10, height: 10, opacity: 0.7 }} src="/images/close.svg" alt="" />
                                </div>

                            </div>
                            <div className="pt-1 pb-3 px-3">
                                <button onClick={() => this.openConfig()} className="py-3 w-100 flexc px-0" style={{ borderBottom: '1px solid #eee' }}>
                                    <img className="mrd-3" src="/assets/icons/useful/settings.svg" width="24px" />
                                    <div className="text-start mb-1">
                                        <p className="text-normal">Configure</p>
                                        <p className="text-smaller" style={{ lineHeight: 1, opacity: 0.3 }}>Double click on component for faster access</p>
                                    </div>
                                </button>



                                <button className="py-3 w-100 flexc px-0" style={{ borderBottom: '1px solid #eee' }}>
                                    <img className="mrd-3" src="/assets/icons/useful/copy-g.svg" width="24px" />
                                    <p className="text-normal">Clone</p>
                                </button>

                                <button onClick={() => this.removeConfirmModal.showModal()} className="py-3 px-0 w-100 flexc" style={{ borderBottom: '0px solid #eee' }}>
                                    <img className="mrd-3" src="/assets/icons/useful/remove-g.svg" width="24px" />
                                    <p className="text-normal">Remove</p>
                                </button>

                            </div>
                        </div>
                    </div>
                </Modal>



                <Modal ref={el => this.removeConfirmModal = el} maxWidth={300} hideCloseBut={true}>
                    <div className="w-100  text-center position-relative" style={{ backgroundColor: '#ffffff', borderRadius: 8 }}>

                        <div className="position-absolute top-0 left-0 w-100" style={{ borderRadius: '8px 8px 0px 0px', zIndex: 0, height: 80, background: 'linear-gradient(to bottom,#FF617460,#fff)', }}>

                        </div>
                        <div className="position-relative px-4">
                            <div className="w-100 pt-3 pb-2" style={{ zIndex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', borderRadius: '8px 8px 0px 0px' }}>

                                {/* <div className="w-100" style={{ zIndex: 1, padding: '8px 15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#dd3030dd,#ee5050dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}> */}

                                <div className="text-start">
                                    {/* <p className="text-smallest mt-2 opacity-5" style={{ lineHeight: 0.5 }}>WHAT TO DO?</p> */}
                                    <p className="text-normal text-semibold" >{translate('Remove')}</p>

                                </div>

                                <div className="cursor-pointer" onClick={() => this.removeConfirmModal.hideModal()} style={{ width: 28, height: 28, backgroundColor: '#ffffff90', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img style={{ width: 10, height: 10, opacity: 0.7 }} src="/images/close.svg" alt="" />
                                </div>
                                {/* <div className="cursor-pointer" onClick={() => this.removeConfirmModal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img className="invert" style={{ width: 14, height: 14 }} src="/assets/icons/useful/close.svg" alt="" />
                                </div> */}

                            </div>
                            <div className="py-2 ">

                                <p className="text-small  pb-3 pt-2 text-start color-gray-1" style={{ borderBottom: '1px solid #eee' }}>{translate("Are you sure you want to remove this component?")}</p>


                                <button onClick={() => this.removeCurrentComponent()} className="py-3 px-0 w-100 flexc" style={{ borderBottom: '1px solid #eee' }}>
                                    <img className="mrd-3" src="/assets/icons/applets/general/warning.png" width="24px" />
                                    <p className="text-normal text-semibold">Remove</p>
                                </button>


                                <button onClick={() => this.removeConfirmModal.hideModal()} className="py-3 px-0 w-100 flexc" style={{ borderBottom: '0px solid #eee' }}>
                                    <img className="mrd-3" src="/assets/icons/useful/cancel-g.svg" width="24px" />
                                    <p className="text-normal">Cancel</p>
                                </button>
                            </div>

                        </div>
                    </div>
                </Modal>



                <Modal ref={el => this.configModal = el} maxWidth={500}>
                    <div className="w-100  text-center position-relative" style={{ backgroundColor: '#ffffff', borderRadius: 8, }}>


                        {/* <div className="position-absolute top-0 left-0 w-100" style={{ borderRadius: '8px 8px 0px 0px', zIndex: 2, height: 50, background: 'linear-gradient(to bottom,#CFD3EF,rgb(238,239,250))', }}>

                        </div>

                        <div className="position-absolute top-0 left-0 w-100" style={{ borderRadius: '8px 8px 0px 0px', zIndex: 0, height: 80, background: 'linear-gradient(to bottom,#CFD3EF,transparent)', }}>

                        </div> */}


                        {/* <div className="position-absolute top-0 left-0 w-100 h-100" style={{zIndex: 1, }}> 
                            <div className=" top-0 left-0 w-100" style={{ position: 'sticky',  top: 0, borderRadius: '8px 8px 0px 0px', height: 50, background: 'linear-gradient(to left,#ADE9D8,#A1F5F8)', }}>

                            </div>
                        </div> */}

                        <div className="w-100 flexcb px-4  pb-2" style={{ paddingTop: 10, zIndex: 3, position: 'sticky', top: 0, borderBottom: '0px #eee solid', background: 'linear-gradient(to left,#fff,#fff)', borderRadius: '8px 8px 0px 0px' }}>

                            <div className="text-start ">
                                {/* <p className="text-smallest mt-2 opacity-5" style={{ lineHeight: 0.5 }}>CONFIGURE</p> */}
                                <p className="text-semibold text-semibig">{checkTranslation(this.state.currentComponent?.title)}</p>
                            </div>

                            <div className="flexc" style={{ backgroundColor: '#f2f6f8' }}>
                                <button onClick={() => this.ConfigurationDone()} className=" flexc px-3 mx-1 flexcc" style={{ height: 30, background: '#ffffff50', borderRadius: 20 }}>
                                    <p className="text-normal">{translate('Done')}</p>
                                </button>

                                {/* <div className="cursor-pointer flexcc" onClick={() => this.configModal.hideModal(() => { this.removeDoneEventListener() })} style={{ width: 30, height: 30, borderRadius: '50%', backgroundColor: '#ffffff50' }}>
                                    <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
                                </div> */}

                                <div className="cursor-pointer" onClick={() => this.configModal.hideModal(() => { this.removeDoneEventListener() })} style={{ width: 28, height: 28, backgroundColor: '#ffffff90', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img style={{ width: 10, height: 10, opacity: 0.7 }} src="/images/close.svg" alt="" />
                                </div>

                            </div>


                        </div>




                        {/* <div className="py-3 px-3 position-relative" style={{zIndex:0}}>
                            <p className="text-small text-start color-gray-4 mb-3 px-3">{translate('Insert related information for this component. If you need help please click here.')}</p>

                            <FormViewer optionsList={this.state.optionsList} variables={variables} ref={el => this.form = el} headers={this.state.currentDiagramComponent?.headers} initData={this.state.currentHeadersData} errors={this.state.errors} inputClass={'modern-input'} liveChange={this.formLiveChange} isEditing={false} />

                        </div> */}
                    </div>

                </Modal>



                <DiagramComponentConfig ref={el => this.diagramComponentConfig = el} variables={variables} optionsList={this.state.optionsList} currentComponent={this.state.currentComponent} width={this.props.width} headers={this.state.currentDiagramComponent?.headers} initData={this.state.currentHeadersData} errors={this.state.errors} liveChange={this.formLiveChange} />

                <DiagramVariablesSidebar ref={el => this.diagramVariablesSidebar = el}  width={this.props.width} variables={this.props.variables} />

            </div>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DiagramEditor)
